import React from "react";
import { Switch as HeadlessSwitch } from "@headlessui/react";
import clx from "classnames";

import styles from "./Switch.module.css";

interface CheckboxEvent {
    target: {
        value: boolean;
        checked: boolean;
        name: string;
    };
    type: 'checkbox';
}

interface Props {
    isOn?: boolean;
    onChange?: (isOn: boolean, event: CheckboxEvent) => void;
    disabled?: boolean;
    label: string;
    className?: string;
    name?: string;
}

const Switch = ({ isOn, onChange, disabled, label, className, name }: Props) => {
    const cn = clx(
        {
            "!bg-midnight-500": isOn,
            "!bg-pine-600": !isOn,
            "!bg-pine-1000 !pointer-events-none": disabled,
        },
        styles.track,
        className
    );

    const dotCn = clx(
        {
            "!left-[1.75rem] !bg-mint-500": isOn,
            "!left-[0.25rem] !bg-pine-100": !isOn,
            "!bg-pine-800": disabled,
        },
        styles.dot
    );

    const handleChange = !disabled && onChange ? () => {
        const value = !isOn || false
        onChange(value, {
            target: {
                value,
                checked: value,
                name: name || ''
            }, 
            type: 'checkbox',
        });
    } : undefined;

    return (
        <HeadlessSwitch checked={isOn} onChange={handleChange} name={name} className={cn}>
            <span className="sr-only">{label}</span>
            <span className={dotCn} />
        </HeadlessSwitch>
    );
};

export default Switch;
